module.exports = __webpack_public_path__ + "img/tr-delete-icon.862bc693.svg";